import { render, staticRenderFns } from "./selectBank.vue?vue&type=template&id=a2967034&scoped=true&"
import script from "./selectBank.vue?vue&type=script&lang=js&"
export * from "./selectBank.vue?vue&type=script&lang=js&"
import style0 from "./selectBank.vue?vue&type=style&index=0&id=a2967034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2967034",
  null
  
)

export default component.exports